import { HashCode } from "@/CommonDP/components/DrawFlow/src/utils";
import Vue from "vue";
import { Message } from "element-ui";
import flowService from "@/CommonDP/service/flow-service";

export const FLOW_INSTANCE_STATUS_DICT = [
  { value: 1, label: "已通过" },
  { value: 2, label: "审批中" },
  { value: 3, label: "已撤回" },
  { value: 0, label: "已驳回" }
];

export const FLOW_INSTANCE_STATUS_ALL_DICT = [{ value: null, label: "全部" }, ...FLOW_INSTANCE_STATUS_DICT];

// 审批状态
export function getStatusName(status) {
  const statusDesccribe = {
    1: () => "已通过",
    2: () => "审批中",
    3: () => "已撤回",
    8: () => "终止",
    9: () => "草稿",
    0: () => "已驳回"
  };
  return statusDesccribe[Number(status)] ? statusDesccribe[Number(status)]() : "";
}
// 基础设置初始化
function basicInitForm() {
  return {
    groupName: "", // 分组名称
    groupId: "", // // 分组id
    flowName: "", // 流程名称
    flowKey: "", // 流程编码
    isInternal: 0,
    startMode: "std",
    methodInvokeMode: "std",
    cadCanStart: 0,
    icon: 0,
    ccList: [], // 上传文件
    printTemplateFileId: "", // 设计打印的文件id
    printTemplateFileVersion: "", // 设计打印的文件版本
    isPdfPrintTemplate: "", // 设计打印的输出的文件是否为pdf
    printTemplateName: "", // 设计打印的文件名称
    printTemplateFolderId: "", // 设计打印的文件存储的目录
    printTemplateFolderName: "", // 设计打印的文件存储的目录名称
    printTemplateFolderTypeId: "", // 设计打印的文件存储的目录模板的从属id
    sameFilePolicy: "", // 0覆盖，1-重命名
    autoGenPrintFile: 1, // 是否下载成果文件时生成成果文件 0或空-否，1-是
    isNewDirectory: "", // 是否新建目录保存成果文件 0或空-否，1-是
    newFolderName: "", // 新建保存成果文件目录名
    description: "",
    formGroupId: "", // 表单分组id
    formName: "",
    formType: 0, // 表单类型；1：项目表单
    prjCategoryList: "",
    isLimitByPrjCategory: 0,
    customerForm: 1, // 表单采用自定义还是在线设计 --1:自定义表单；2：在线表单
    isStartByNoAssignee: 1, // 无审批人是否可发起流程
    enablePrjSelector: 0, // 是否提供项目选择器
    formCode: "", // 发起表单(pc)
    formH5Code: "", // 发起表单(h5)
    formApprovePcCode: "", // 审批表单(pc)
    formApproveH5Code: "", // 审批表单(h5)
    titleTemplate: "", // 流程标题
    contentTemplate: "" // 流程摘要
  };
}
function permInitForm() {
  return {
    rejectRuleCode: 0, // 驳回规则
    noApproveUserStrategy: 1, // 异常处理
    defaultApproveUserId: "", // 异常处理为2时,默认处理人id
    defaultApproveUserName: "", // 异常处理为2时,默认处理人
    autoApprovalStrategy: 3, // 自动审批
    allowDelegatorSubmit: "", // 提交权限 是否允许代理他人提交
    allowAddApproverDynamic: "", // 加签权限 是否允许动态增加审批人
    userList: [],
    permissionList: [] // userType  取值有 user/sysRole/prjRole/specRole/tag
  };
}
// 表单对应的字段——流程权限时使用
function initFormFieldList() {
  return {
    web: [],
    H5: []
  };
}
// 流程参数管理
export const flowParams = Vue.observable({
  // 基础设置
  basicForm: basicInitForm(),
  // 权限设置
  permForm: permInitForm(),
  // 流程数据，只允许数组
  flowNode: [],
  flowImage: "",
  // formGroupId: "", // 表单分组id
  // formName: "", // 表单名称
  attachedFiles: [], // 附加文件表
  selectFormList: "", // 新建流程模板的选择表单
  flowDefinitionId: "", // 流程id
  currentVersionId: "", // 版本id
  formFieldList: initFormFieldList()
});
export function updateParams(type, params) {
  flowParams[type] = {
    ...params
  };
}
export function updateNode(nodes) {
  flowParams.flowNode = nodes;
}
export function updateflowImage(base64) {
  flowParams.flowImage = base64;
}
export function setGroupName(val) {
  flowParams.basicForm.groupName = val.name;
  flowParams.basicForm.groupId = val.id;
}
export function setFormList(array) {
  flowParams.selectFormList = array || [];
}
export function setFormFieldList(type, array) {
  flowParams.formFieldList[type] = array || [];
}
export function setFormFieldNull() {
  flowParams.formFieldList = initFormFieldList();
}
export function setWebFieldList(array) {
  flowParams.formFieldList.web = array || [];
}
export function getFormFieldList() {
  return flowParams.formFieldList.web || flowParams.formFieldList.H5;
}
// 数据初始化
export function updateInit() {
  const { groupName, groupId } = flowParams.basicForm;
  flowParams.flowDefinitionId = "";
  flowParams.currentVersionId = "";
  flowParams.basicForm = basicInitForm();
  flowParams.permForm = permInitForm();
  flowParams.flowNode = [];
  flowParams.attachedFiles = [];
  flowParams.basicForm.groupName = groupName;
  flowParams.basicForm.groupId = groupId;
  setFormFieldNull();
}
// 查看编辑回显数据
export function setFormData(obj) {
  const { groupName, groupId } = flowParams.basicForm;
  flowParams.flowDefinitionId = obj.flowDefinitionId || "";
  flowParams.currentVersionId = obj.currentVersionId || "";
  flowParams.basicForm = {
    groupName: obj.groupName || groupName,
    groupId: obj.groupId || groupId,
    flowName: obj.flowName,
    flowKey: obj.flowKey,
    isInternal: obj.isInternal === true ? 1 : 0,
    formType: obj.formType || 0,
    startMode: obj.startMode,
    methodInvokeMode: obj.methodInvokeMode,
    isStartByNoAssignee: obj.isStartByNoAssignee === 0 ? 0 : 1,
    cadCanStart: obj.cadCanStart,
    printTemplateFileId: obj.printTemplateFileId,
    printTemplateFileVersion: obj.printTemplateFileVersion,
    isPdfPrintTemplate: obj.isPdfPrintTemplate || 0,
    printTemplateName: obj.printTemplateName,
    printTemplateFolderId: obj.printTemplateFolderId,
    printTemplateFolderName: obj.printTemplateFolderName,
    printTemplateFolderTypeId: obj.printTemplateFolderTypeId,
    sameFilePolicy: obj.sameFilePolicy || 0,
    autoGenPrintFile: [0, 1].includes(obj.autoGenPrintFile) ? obj.autoGenPrintFile : 1,
    isNewDirectory: obj.isNewDirectory,
    newFolderName: obj.newFolderName,
    icon: obj.icon,
    ccList: obj.ccList.map((e) => {
      return {
        ...e,
        name: e.userName
      };
    }),
    isLimitByPrjCategory: obj.isLimitByPrjCategory,
    prjCategoryList: obj.prjCategoryList?.map((item) => item.prjCategoryId),
    description: obj.description,
    customerForm: obj.customerForm || 1,
    formCode: obj.formCode || "",
    formH5Code: obj.formH5Code || "",
    formApprovePcCode: obj.formApprovePcCode || "",
    formApproveH5Code: obj.formApproveH5Code || "",
    titleTemplate: obj.titleTemplate,
    contentTemplate: obj.contentTemplate,
    enablePrjSelector: obj.enablePrjSelector || 0
  };
  flowParams.permForm = {
    rejectRuleCode: obj.rejectRuleCode,
    noApproveUserStrategy: obj.noApproveUserStrategy,
    defaultApproveUserId: obj.defaultApproveUserId,
    defaultApproveUserName: obj.defaultApproveUserName,
    autoApprovalStrategy: obj.autoApprovalStrategy,
    allowDelegatorSubmit: obj.allowDelegatorSubmit,
    allowAddApproverDynamic: obj.allowAddApproverDynamic,
    userList: [{ type: 0, userId: obj.defaultApproveUserId, name: obj.defaultApproveUserName }],
    permissionList:
      obj.permissionList?.map((e) => {
        return {
          ...e,
          id: e.userId,
          name: e.userName,
          nodeId: e.userId,
          selectName: e.userName,
          selectCode: getUserType(e.userType)
        };
      }) || []
  };
  flowParams.flowDefinitionId = obj.flowDefinitionId || "";
  flowParams.attachedFiles = obj.attachedFiles || [];
  flowParams.flowNode = JSON.parse(obj.nodes);
  console.log("flowParams", flowParams);
}
export function getFlowNode() {
  return flowParams.flowNode;
}
export function changeFloderData(val) {
  flowParams.attachedFiles.push(val);
}
export function deleteFloderData(val) {
  flowParams.attachedFiles = flowParams.attachedFiles.filter((e) => e.fileId !== val.fileId);
}
export function dealFrom(data) {
  function traversal(data) {
    for (const info of data) {
      if (info.children) {
        if (info.children.length > 0) {
          traversal(info.children);
        }
        if (info.children.some((e) => e.groupName === "表单页面")) {
          info.children = info.children.find((e) => e.groupName === "表单页面").children;
        }
      }
    }
  }
  traversal(data);
}
const initApproveParams = () => ({
  draftBusinessId: "", // 暂存id 没有默认为空
  businessType: "", // 业务类型 默认"dynForm"
  ccUserIdList: [], // 流程完成后的抄送人
  clientType: 0, // 发起流程来源;0web;1cad;2revit;默认0
  enterpriseId: "", // 企业id
  flowDefinitionId: "", // 当前流程id
  flowKey: "",
  flowNodeDtoList: [], // 节点用户
  json: {}, // 基本信息中表单的业务数据
  prjId: "", // 项目id
  enablePrjSelector: 0, // 是否由框架层提供项目选择器
  startFlowMode: 0 // 发起流程方式;0审批入口;1右键;默认0
});

const detailApplicationParams = () => ({
  version: "",
  definitionId: "", // 流程定义id
  flowKey: "",
  flowInstanceId: "", // 流程实例id
  status: ""
});
// 审批参数管理
export const approveParams = Vue.observable({
  start: initApproveParams(), // 发起流程
  detail: detailApplicationParams(), // 审批流程
  fileInfoList: [], // 附件文件列表
  name: "",
  version: "", // 流程版本
  definitionId: "", // 流程id
  flowKey: "", // 流程编码
  methodInvokeMode: "std", // 是否调用标准的流程接口:std 是 ，customize 否
  nodeList: [],
  nodeAssigneeList: {}, // 审批节点的处理人，处理（仅适用于审批时才选择下一个节点处理人的场景）
  formType: 0, // 是否为项目内流程
  prjId: "" // 项目id
});

export function isPrjFlow() {
  return approveParams.formType === 1;
}

function getUserType(userType) {
  switch (userType) {
    case "user":
      return "User";
    case "sysRole":
      return "SystemRole";
    case "specRole":
      return "SpecRole";
    case "prjRole":
      return "PrjRole";
    case "tag":
      return "Label";
    default:
      return "";
  }
}
// 初始化 添加流程的字段
export function initApproval() {
  approveParams.start = initApproveParams();
  approveParams.detail = detailApplicationParams();
  approveParams.fileInfoList = []; // 附件文件列表
  approveParams.name = "";
  approveParams.version = "";
  approveParams.definitionId = "";
  approveParams.flowKey = "";
  approveParams.formType = 0;
}

export function setBasicJson(val) {
  approveParams.start.json = val;
}
// 设置流程项目id
export function setPrjID(id) {
  approveParams.prjId = id || "";
}
export function setEnablePrjSelector(enablePrjSelector) {
  approveParams.start.enablePrjSelector = enablePrjSelector || 0;
}

// 详情的表单附件列表处理
export async function setStartAttachedFiles(val) {
  const flowKey = approveParams.flowKey;
  if (flowKey === "check") {
    const request = val.map((element) => setFilePath(element.fileId).then((data) => ({ ...element, ...data })));
    const data = await Promise.all(request);
    approveParams.fileInfoList = data;
  } else {
    approveParams.fileInfoList = val;
  }
  console.log("附件信息", approveParams.fileInfoList);
}
// 查找校审路径
async function setFilePath(fileId) {
  const { data } = await flowService.getAssociatedFileLocation(fileId);
  if (data.length > 0) {
    return {
      paths: data,
      pathName: data.map((e) => e.folderName).join("/")
    };
  } else {
    return {
      paths: [],
      pathName: ""
    };
  }
}

export function addStartAttachedFiles(array) {
  const flowFileList = approveParams.fileInfoList;
  for (const iterator of array) {
    if (flowFileList.some(({ fileName }) => iterator.fileName === fileName)) {
      Message.warning(`${iterator.fileName}上传失败，已存在同名文件`);
    } else {
      approveParams.fileInfoList.push(iterator);
    }
  }
}
export function deleteStartAttachedFiles(val) {
  approveParams.fileInfoList = approveParams.fileInfoList.filter((e) => e.fileId !== val.fileId);
}

export function setCcUserIdList(val) {
  approveParams.start.ccUserIdList = val.map((user) => user.userId);
}
// 设置审批人用户 flowNodeDtoList是把审批人抄送人放一起处理的根据后台根据type做的区分
export function setFlowNodeDtoList(list, type) {
  approveParams.nodeList = list || [];
  // 发起流程的节点处理人
  if (type === "add") {
    approveParams.start.flowNodeDtoList = list.map((row) => {
      const assigneeList = row.assigneeList.map((e) => {
        return {
          ...e,
          type: 0 // 用户类型 0：审批人(默认) 1：抄送人
        };
      });
      const ccList = row.ccList.map((e) => {
        return {
          ...e,
          type: 1 // 用户类型 0：审批人(默认) 1：抄送人
        };
      });
      return {
        ...row,
        flowNodeDefinitionId: row.flowNodeDefinitionId,
        assigneeSelectionStrategy: row.assigneeSelectionStrategy,
        userDtoList: [...assigneeList, ...ccList]
      };
    });
  } else {
    // 审批的节点处理人
    approveParams.nodeAssigneeList = list.map((row) => {
      const assigneeList = row.assigneeList.map((e) => {
        return {
          ...e,
          type: 0 // 用户类型 0：审批人(默认) 1：抄送人
        };
      });
      return {
        ...row,
        flowNodeDefinitionId: row.flowNodeDefinitionId,
        userDtoList: [...assigneeList]
      };
    });
  }
  console.log(approveParams.start.flowNodeDtoList, "approveParams.start.flowNodeDtoList");
}
// 设置下个节点的处理人，仅适用于审批时才选择下一个节点处理人的场景 --作废
// 设置节点处理人
export function setNodeUserDtoList(list, flowNodeDefinitionId) {
  approveParams.nodeAssigneeList.forEach((element) => {
    if (element.flowNodeDefinitionId === flowNodeDefinitionId) {
      element.userDtoList = list;
    }
  });
}
// 更新发起审批的处理人
export function changeFlowNodeDtoList(flowNodeDefinitionId, list) {
  const flowNodeDtoList = approveParams.start.flowNodeDtoList;
  flowNodeDtoList.forEach((element) => {
    if (element.flowNodeDefinitionId === flowNodeDefinitionId) {
      element.userDtoList = list;
    }
  });
  // console.log("flowNodeDtoList", approveParams.start.flowNodeDtoList);
}
// 删除发起审批的处理人
export function deleteFlowNodeDtoList(flowNodeDefinitionId, id) {
  const flowNodeDtoList = approveParams.start.flowNodeDtoList;
  flowNodeDtoList.forEach((element) => {
    if (element.flowNodeDefinitionId === flowNodeDefinitionId) {
      element.userDtoList = element.userDtoList.filter((e) => e.userId !== id && e.type === 0);
    }
  });
}
// 添加发起审批的处理人
export function addFlowNodeDtoList(flowNodeDefinitionId, users) {
  const flowNodeDtoList = approveParams.start.flowNodeDtoList;
  flowNodeDtoList.forEach((element) => {
    if (element.flowNodeDefinitionId === flowNodeDefinitionId) {
      const userApproveList = element.userDtoList?.filter((e) => e.type === 0) || [];
      for (const user of users) {
        if (!userApproveList.some((e) => e.userId === user.userId)) {
          const newUser = { ...user, type: 0, userName: user.name };
          element.userDtoList.push(newUser);
        }
      }
    }
  });
  console.log("userDtoList", flowNodeDtoList);
}
// 设置新建流程的数据
export function setDefaultApproval(row, enterpriseId) {
  // console.log(row, "row");
  approveParams.name = row.name || row.businessName;
  approveParams.version = row.currentVersionId;
  approveParams.definitionId = row.id || row.flowDefinitionId;
  approveParams.flowKey = row.flowKey;
  approveParams.methodInvokeMode = row.methodInvokeMode || "std";
  approveParams.formType = row.formType || 0;

  approveParams.start.flowDefinitionId = row.flowDefinitionId || "";
  approveParams.start.flowKey = row.flowKey;
  approveParams.start.enablePrjSelector = row.enablePrjSelector || 0;
  approveParams.start.enterpriseId = enterpriseId;
  approveParams.start.draftBusinessId = row.draftBusinessId || "";
  approveParams.start.businessType = row.businessType;
  approveParams.start.clientType = row.clientType;
  approveParams.start.json = row.json || "";
  approveParams.fileInfoList = row.json?.fileInfoList || []; // 附件文件列表
  approveParams.prjId = row.prjId;
  approveParams.start.startFlowMode = row.startFlowMode;
}
export function setApprovalParams(row) {
  // TODO 后台接口暂时没存这两个信息，所以先这样处理
  // approveParams.start.ccUserIdList = []; // 流程完成后的抄送人
  // approveParams.start.flowNodeDtoList = [];
  approveParams.start.businessType = row.businessType;
  approveParams.start.clientType = row.clientType;
  approveParams.start.enterpriseId = row.enterpriseId;
  approveParams.start.flowDefinitionId = "";
  approveParams.start.json = row.json;
  approveParams.start.flowKey = row.flowKey;
  approveParams.prjId = row.prjId;
  approveParams.start.enablePrjSelector = row.enablePrjSelector || 0;
  approveParams.start.startFlowMode = row.startFlowMode;
  approveParams.fileInfoList = row.json.fileInfoList || []; // 附件文件列表
  approveParams.name = row.businessName;
  approveParams.version = "";
  approveParams.definitionId = "";
  approveParams.flowKey = row.flowKey;
  approveParams.formType = row.formType || 0;
  approveParams.methodInvokeMode = row.methodInvokeMode;
}
// 审批查看设置默认属性
export function setDetailParams(row, enterpriseId) {
  approveParams.detail = row;
  approveParams.name = row.businessName || row.flowName;
  approveParams.version = row.currentVersionId;
  approveParams.definitionId = row.flowDefinitionId;
  approveParams.flowKey = row.businessType || row.flowKey;
  approveParams.methodInvokeMode = row.methodInvokeMode || "std";
  approveParams.formType = row.formType;

  approveParams.start.flowDefinitionId = row.flowDefinitionId;
  approveParams.start.flowKey = row.businessType || row.flowKey;
  approveParams.start.enablePrjSelector = row.enablePrjSelector || 0;
  approveParams.start.enterpriseId = enterpriseId;
}
// 默认流程图数据
export const defaultInitFlowConfig = [
  {
    id: HashCode(),
    groupId: null,
    pids: [],
    groupPid: null,
    childFlowIdx: "",
    type: "1",
    title: "申请人本人",
    members: [],
    memberType: "None",
    content: "申请人本人",
    approve: "None",
    row: true,
    root: true,
    data: {},
    cond: []
  }
];
